import { ThrowableStatus } from "@wss/error-tracking/throwable";

const fetchIsEmailValidForForm = async (
  email: string,
  formId: number,
): Promise<ThrowableStatus<boolean>> => {
  try {
    const response = await fetch("/api/pagecreator/validate-email/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        formId,
      }),
    });

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }

    // The validate-email endpoint returns whether the email has been recorded by the Partners API for this form,
    // so we flip the response to get whether the email is currently valid.
    const isValid = !(await response.json());

    return { isError: false, value: isValid };
  } catch (e) {
    return {
      isError: true,
      status: null,
      error: new Error("Failed to fetch email validity from Partners API.", {
        cause: e,
      }),
    };
  }
};

export default fetchIsEmailValidForForm;
